import React, { useContext, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FaSearch, FaSpinner } from "react-icons/fa";
import searchDocContext from "../context/searchDocument/searchDocContext";

export default function InputTextField() {
  const { seachDocumentFun, startLoading } = useContext(searchDocContext);
  const [searchParams] = useSearchParams();
  const [searchDoc, setSearchDocID] = useState(() => (searchParams.get("id") || "").trim());
  const autoSearched = useRef(false);

  // Certificates carry a QR code pointing to /?id=<Report No.>; verify it
  // immediately so the visitor does not have to retype the ID.
  useEffect(() => {
    const id = (searchParams.get("id") || "").trim();
    if (id && !autoSearched.current) {
      autoSearched.current = true;
      setSearchDocID(id);
      seachDocumentFun(id);
    }
  }, [searchParams, seachDocumentFun]);

  const handleSearch = (e) => {
    e.preventDefault();
    seachDocumentFun(searchDoc);
  };

  return (
    <form onSubmit={handleSearch} className="vp-input-form">
      <div className="vp-input-wrap">
        <FaSearch className="vp-input-icon" />
        <input
          type="search"
          className="vp-input"
          placeholder="Enter Certificate No. or ID No. (CNIC)..."
          value={searchDoc}
          onChange={(e) => setSearchDocID(e.target.value)}
          aria-label="Certificate or ID number"
          autoComplete="off"
        />
        <button
          type="submit"
          className="vp-input-btn"
          disabled={startLoading}
          aria-label="Verify"
        >
          {startLoading ? (
            <>
              <FaSpinner className="vp-spin" />
              Verifying...
            </>
          ) : (
            <>
              <FaSearch />
              Verify Now
            </>
          )}
        </button>
      </div>
      <p className="vp-input-hint">
        Search by Certificate No. (e.g. TAC25067) or ID No. / CNIC printed on your document.
      </p>
    </form>
  );
}
